import { useState, SyntheticEvent, useEffect } from 'react';
import { WorkBackgroundForm } from './components/work-background-form';
import { PostConsultantWorkBackgroundModel } from '../../models';
import { Button, Col, FlexboxGrid, Radio, RadioGroup } from 'rsuite';
import { ValueType } from 'rsuite/esm/Checkbox';
import { handleGetConsultantWorkBackground } from '../../api-handler';
import { useNavigate } from 'react-router-dom';
// import { showToast } from '../../utils/toast';
import { CustomLoader } from '../../components/basic/loader';

export const ConsultantWorkBackground = (props: {
  disabledMode?: boolean;
  isAdmin?: boolean;
  username?: string;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);

  const [workData, setWorkData] = useState<(PostConsultantWorkBackgroundModel | null)[]>([]);
  const [isWorking, setIsWorking] = useState<ValueType>('yes');

  const handleAddWorkData = (
    newData: PostConsultantWorkBackgroundModel | null,
    isCurrent: boolean
  ) => {
    console.log('update array', newData, isCurrent);
    if (isCurrent) {
      return setWorkData((prev) => {
        return [newData, ...prev.slice(1, -1)];
      });
    }
    return setWorkData((prev) => {
      return [...prev, newData];
    });
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const res = await handleGetConsultantWorkBackground(props.isAdmin ? props.username : null);
      if (res.ok) {
        if (!res.data[0].CurrentWork) {
          setWorkData([null, ...res.data]);
          setIsWorking('no');
        } else {
          setWorkData([...res.data]);
        }
        // todo handle is working button
        console.log(editMode);
        setEditMode(true);
      }
      setLoading(false);
    })();
  }, [props.username]);

  if (loading) {
    return <CustomLoader />;
  }
  return (
    <>
      <h4 className="text-h4">{props.isAdmin ? 'سوابق شغلی' : 'سوابق شغلی خود را وارد کنید'}</h4>

      <FlexboxGrid className="mt-8">
        <FlexboxGrid.Item as={Col} colspan={24} sm={24} md={6} lg={5} className="max-w-[100%]">
          <RadioGroup
            value={isWorking}
            dir="rtl"
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            disabled={props.disabledMode || editMode}
            onChange={(value: ValueType, _event: SyntheticEvent<Element, Event>) =>
              setIsWorking(value)
            }>
            <div className="flex items-center">
              <div className="w-[50%]">مشغول به کار</div>
              <Radio className="w-[25%]" value={'yes'}>
                بله
              </Radio>
              <Radio className="w-[25%]" value={'no'}>
                خیر
              </Radio>
            </div>
          </RadioGroup>
        </FlexboxGrid.Item>
      </FlexboxGrid>

      {workData.map((item, index) => {
        return isWorking !== 'yes' && index === 0 ? null : (
          <WorkBackgroundForm
            key={`${item?.RandomId}-${index}`}
            handleAddWorkData={handleAddWorkData}
            currentWorking={index === 0}
            readonly={index === 0 && isWorking === 'yes' && item === null ? false : true}
            hideNextButton={index === 0 && isWorking === 'yes' && item === null ? true : false}
            defaultValue={item}
            disabledMode={props.disabledMode}
          />
        );
      })}
      {/* todo: handle edit mode */}
      {!editMode && workData.length ? (
        <WorkBackgroundForm
          handleAddWorkData={handleAddWorkData}
          currentWorking={false}
          forceReadOnly={loading}
          disabledMode={props.disabledMode}
        />
      ) : !editMode && isWorking === 'yes' ? (
        <WorkBackgroundForm
          handleAddWorkData={handleAddWorkData}
          currentWorking={true}
          forceReadOnly={loading}
          disabledMode={props.disabledMode}
        />
      ) : !editMode && !props.disabledMode ? (
        <Button
          appearance="primary"
          className="ml-auto mt-4"
          type="button"
          onClick={() => handleAddWorkData(null, false)}
          loading={loading}>
          افزودن سابقه جدید
        </Button>
      ) : null}
      {editMode && !props.disabledMode ? (
        <div className="flex justify-between">
          <Button
            appearance="default"
            className="ml-auto mt-8"
            type="button"
            onClick={() => {
              navigate('/consultant/personal');
              // showToast('اطلاعات قبلا ثبت شده', 'warning');
            }}
            loading={loading}>
            مرحله قبل
          </Button>
          <Button
            appearance="primary"
            className="mr-auto mt-8"
            type="button"
            onClick={() => {
              navigate('/consultant/education');
              // showToast('اطلاعات قبلا ثبت شده', 'warning');
            }}
            loading={loading}>
            مرحله بعد
          </Button>
        </div>
      ) : null}
    </>
  );
};
